module.exports = __webpack_public_path__ + "img/xinjiang.1c37b7ec.jpg";